export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const GET_EMPLOYEES_REQUEST = "GET_EMPLOYEES_REQUEST";
export const GET_EMPLOYEES_FAILURE = "GET_EMPLOYEES_FAILURE";
export const PATCH_EMPLOYEE = "PATCH_EMPLOYEE";
export const CREATE_EMPLOYEE_FAILURE = "CREATE_EMPLOYEE_FAILURE";
export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
